export function positionReplayHref(symbol: string, accountId: string): string {
  return `/positions/${encodeURIComponent(symbol)}?accountId=${encodeURIComponent(accountId)}`;
}
